import { createContext } from "react"

export interface PointsContextType {
  pointsState: any
  setPointsState: any
}

export const PointContext = createContext<PointsContextType | null>(null)
